module.exports = __webpack_public_path__ + "img/vegetable-cauliflower-350x184.44a4c471.jpg";